<div
  class="flex flex-col flex-nowrap loading-container"
  [attr.data-testid]="'loading-container'"
>
  <mat-progress-spinner
    [mode]="mode"
    color="primary"
    [value]="value"
    [attr.data-testid]="'loading-spinner'"
  >
  </mat-progress-spinner>
  <div class="text-center" [attr.data-testid]="'loading-content'">
    <ng-content></ng-content>
  </div>
</div>
